"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.setVisibility = exports.setSize = exports.setAverage = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const initialState = {
    clusterAverage: null,
    clusterSize: null,
    loading: false,
    visible: false,
};
const clusterSlice = (0, toolkit_1.createSlice)({
    name: "cluster",
    initialState,
    reducers: {
        setAverage: (state, action) => {
            state.clusterAverage = action.payload;
        },
        setSize: (state, action) => {
            state.clusterSize = action.payload;
        },
        setVisibility: (state, action) => {
            state.visible = action.payload;
        },
    },
});
_a = clusterSlice.actions, exports.setAverage = _a.setAverage, exports.setSize = _a.setSize, exports.setVisibility = _a.setVisibility;
exports.default = clusterSlice.reducer;
